import React, { useRef, useEffect } from 'react';
import Calendar from 'react-awesome-calendar';
import { XyzTransition } from '@animxyz/react';
import '@animxyz/core';
import '../../styles/infoBoard.css';

// 👇 helper components
import TabbedView from '../../components/TabbedView';

export default function InfoBoard({ events, fetchEvents, announcements, jobPostings, alumniData }) {
    const calendarRef = useRef();

    // 👇 component did mount
    useEffect(() => {
        // console.log('\nref:', calendarRef.current);
        // console.log('\ndetails:', calendarRef.current?.getDetails());
    }, []);

    // 👇 handler for when date changed or mode changed
    const onDateChanged = (data) => {
        let { mode, year, month, day } = data;
    };

    // 👇 handler for onClick event (in daily mode)
    const onClickEvent = (count) => {
        // console.log('\nEvent #' + count);
    };

    // 👇 handler for onClickTimeLine (the empty part in daily mode)
    const onClickTimeLine = (data) => {
        let { year, month, day, hour } = data;
    };

    const myEvents = () => {
        return events.map((item, index) => ({
            ...item,
            id: item?.uuid,
            from: item?.startDate,
            to: item?.endDate,
            title: item?.name,
        }));
    };

    return (
        <XyzTransition appear duration='auto'>
            <div className='container'>
                <div className='main-content'>
                    <TabbedView
                        events={events}
                        announcements={announcements}
                        jobPostings={jobPostings}
                        alumniData={alumniData}
                        fetchEvents={fetchEvents}
                    />
                </div>
                <div className='calendar'>
                    <Calendar
                        ref={calendarRef}
                        events={myEvents()}
                        onChange={onDateChanged}
                        onClickEvent={onClickEvent}
                        onClickTimeLine={onClickTimeLine}
                    />
                </div>
            </div>
        </XyzTransition>
    );
}
